export function isMenuTileItem(item) {
  if (item == null || typeof item !== 'object') return false
  if (typeof item.isTile === 'boolean') return item.isTile
  const t1 = item.tileTitle
  const t2 = item.tileDescription
  const s1 = t1 != null ? String(t1).trim() : ''
  const s2 = t2 != null ? String(t2).trim() : ''
  // `tileCompleteDescription` es opcional (subtítulo en pantalla); no condiciona la tarjeta del home.
  return !!(s1 && s2)
}

export function collectTileItems(nodes) {
  if (!Array.isArray(nodes)) return []
  const out = []
  const walk = (arr) => {
    for (const n of arr) {
      if (isMenuTileItem(n)) out.push(n)
      const ch = n.children ?? []
      if (Array.isArray(ch) && ch.length) walk(ch)
    }
  }
  walk(nodes)
  return out
}
